var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.097 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13864",
    d: "M35.086 9.578c-.64 0-1.269.035-1.891.091C30.955 3.949 24.414 0 17.011 0 7.631 0-.001 6.255-.001 13.944a12.66 12.66 0 004.791 9.7L3.5 29.46a.789.789 0 001.053.908l7.828-3.006a20.676 20.676 0 006.512.421c2.2 5.608 8.626 9.68 16.191 9.68a20.468 20.468 0 004.629-.523l7.828 3.007a.789.789 0 001.053-.908l-1.289-5.816a12.66 12.66 0 004.791-9.7c0-7.688-7.631-13.942-17.012-13.942zm-22.569 16.2a.788.788 0 00-.471.03l-6.684 2.567 1.077-4.855a.788.788 0 00-.279-.789 11.227 11.227 0 01-4.579-8.783c0-6.818 6.923-12.364 15.433-12.364 6.6 0 12.434 3.37 14.573 8.3-7.705 1.327-13.51 6.939-13.51 13.643a11.526 11.526 0 00.33 2.718 18.99 18.99 0 01-5.887-.466zm33.423 6.53a.788.788 0 00-.279.789l1.076 4.855-6.684-2.567a.792.792 0 00-.283-.052.809.809 0 00-.189.023 18.847 18.847 0 01-4.495.535c-8.51 0-15.433-5.547-15.433-12.364s6.923-12.364 15.433-12.364 15.433 5.547 15.433 12.364a11.229 11.229 0 01-4.579 8.783z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13865",
    d: "M26.28 20.547a2.515 2.515 0 102.515 2.515 2.518 2.518 0 00-2.515-2.515zm0 3.452a.937.937 0 11.937-.937.938.938 0 01-.937.935z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13866",
    d: "M35.086 20.547a2.515 2.515 0 102.515 2.515 2.518 2.518 0 00-2.515-2.515zm0 3.452a.937.937 0 11.937-.937.938.938 0 01-.937.935z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13867",
    d: "M43.892 20.547a2.515 2.515 0 102.515 2.515 2.518 2.518 0 00-2.515-2.515zm0 3.452a.937.937 0 11.937-.937.938.938 0 01-.937.935z"
  }))));
}

export default SvgChat;